<template>
  <div id="deposit-payment-gateway">

    <vs-alert color="warning" class="mb-4" active="true" v-if="this.wallet.internal.name=='toman'">
      {{$t('Payment is only possible through approved accounts, otherwise your payment will be unsuccessful')}}
    </vs-alert>

    <form autocomplete="off" v-on:submit.prevent="submitFormDeposit()">

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <div class="lg:mt-3">{{$t('Amount')}}</div>
        </div>
        <div class="vx-col sm:w-2/3 w-full relative">
          <vs-input class="w-full vazir" icon-pack="feather" :size="!isSmallerScreen?'large':null" icon-no-border icon="icon-hash" v-model="amount"
                    v-validate="'required'" :class="errors.has('amount') && depositSubmit ? 'border-danger':'' " name="amount" maxlength="15"/>
          <span class="label-absolute capitalize">{{$t(wallet.internal.name)}}</span>
        </div>
      </div>

      <div class="vx-row mb-6" v-if="listGatway.length > 1">
        <div class="vx-col sm:w-1/3 w-full">
          <div class="lg:mt-3">{{$t('Payment gateway')}}</div>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <div class="vx-col w-full">
            <vs-select class="w-full" name="gateway" v-validate="'required'" v-model="gateway">
              <vs-select-item :key="index" :value="item.name" :text="$t(item.name)" v-for="(item,index) in listGatway" />
            </vs-select>
          </div>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col sm:w-1/3 w-full">
          <div class="lg:mt-3"></div>
        </div>
        <div class="vx-col sm:w-2/3 w-full flex">
          <vs-button class="mr-3 mb-2" icon-pack="feather" icon="icon-check" :disabled="isLoading"
                     :id="'button-payment-gateway'" @click.prevent="submitFormDeposit">
            {{$t('Go to payment gateway')}}
          </vs-button>
          <vs-button color="dark" type="border" class="mb-2 " :to="'/wallets'">بازگشت</vs-button>
        </div>
      </div>
    </form>
  </div>
</template>
<i18n locale="fa">
{
  "Payment gateway":"درگاه پرداخت"
  ,"Go to payment gateway":"رفتن به درگاه پرداخت"
  ,"Payment is only possible through approved accounts, otherwise your payment will be unsuccessful":
    "پرداخت فقط از طریق حساب های تایید شده امکان پذیر است و در غیر این صورت پرداخت شما ناموفق خواهد بود."
  ,"Select bank account": "انتخاب حساب بانکی"

  }
</i18n>
<script>
    import axios from "../../../../http/axios";

    export default {
      name: "PaymentGateway",
      props: ['wallet','listGatway'],
      data () {
        return {
          isLoading:false,
          depositSubmit:false,
          amount:'',
          gateway:null
        }
      },
      methods:{
        submitFormDeposit(){
          this.$validator.validateAll().then(result => {
              if (result) {
                this.$vs.loading({
                  container: '#button-payment-gateway',
                  scale: 0.65
                })
                const self = this
                axios.post('/wallets/internal/deposit/gateway',
                  {
                    amount: this.amount.replace(/[^\d.-]/g, ''),
                    paymentGateway:this.gateway
                  })
                  .then(function (response) {
                    if (response.data.status == true) {
                        window.location.href = response.data.url
                    }else {
                      self.$vs.notify({title: self.$t('Error'),text: response.data.msg ,iconPack: 'feather',icon: 'icon-alert-circle',color: 'danger'})
                    }
                    self.$vs.loading.close('#button-payment-gateway > .con-vs-loading');
                    self.isLoading = false;
                  }).catch(function (error) { self.$vs.loading.close('#button-payment-gateway > .con-vs-loading'); self.isLoading = false; })
              }else
                this.depositSubmit = true
          })
        },
        getStatusTransaction(id){
          const self = this
          axios.post('/wallets/internal/deposit/gateway/'+id)
            .then(function (response) {
              if (response.data.status == true) {
                self.$swal({
                  icon: 'success',
                  title: self.$t('Success'),
                  text: response.data.msg
                })
              }else {
                self.$swal({
                  icon: 'warning',
                  title: self.$t('Unsuccessful'),
                  text: response.data.msg
                })
              }
              self.$vs.loading.close()
            }).catch(function (error) {})
        }
      },
      watch:{
        amount(value){
          this.amount = this.amountLocalFloat(value,this.wallet.internal.percent)
        }
      },
      mounted() {
        var gateway = this.listGatway.find(o => o.select === 1) ;
        this.gateway = gateway ? gateway.name :  this.listGatway[0].name;
      },
      created() {
        if (this.$route.query.id){
          this.$vs.loading()
          this.getStatusTransaction(this.$route.query.id);
          this.$router.replace({'id': null});
        }
      }
    }
</script>

<style lang="scss">
  #deposit-payment-gateway{
    .label-absolute{
      position: absolute;
      right: 22px;
      top: 18px;
      padding-left: 5px;
    }

    @media only screen and (max-width: 768px) {
      .label-absolute{
        top: 10px;
      }
    }
  }

</style>
